<template>
  <div id="app">
    <loading-component v-show='isShowLoading==1'/>
    <router-view/>
  </div>
</template>

<script>
import LoadingComponent from './components/common/Loading'
import {mapGetters} from 'vuex'
export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {
    isShowLoading: {
      get() {
        return this.$store.state.isShowLoading
      },
      set(newVal) {
        this.isShowLoading = newVal;
      }
    }
  },
  components: {
    LoadingComponent
  }
}
</script>

<style lang="less">
@import './assets/css/style.less';
@import "./assets/css/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue